import React, { Component, useEffect, useState,useRef } from 'react';
import './BudgetTable.css'
import { Row, Col,Spinner } from "react-bootstrap";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { DataGrid, GridColDef, GridSortModel } from "@mui/x-data-grid";
import Tooltip from '@mui/material/Tooltip';
import { toast } from 'react-toastify';

interface Campaign {
    campaignId: string;
    name: string;
    status: string;
    budget: number;
    type: string;
    startDate: string;
    endDate: string | null;
    budgetType:string;
    spend: number;
    sales: number;
    roas:string
    impressions:string
    cpc:string
    clicks:string
    orders:string
    acos:string
    // actionName?: string;
}
interface CampaignsProps{
  condition: string;
}

const Campaigns: React.FC<CampaignsProps> = (props) => {
    const [campaigns, setCampaigns] = useState<Campaign[]>([]);  
    const [perPage, setPerPage] = useState(50);
    const [totalRow, setTotalRow] = useState(0);
    const [activePage, setActivePage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [searchKeyFilter, setSearchKeyFilter] = useState("");
    const [selectedProfile, setSelectedProfile] = useState("");
    const [selectedstatus, setselectedstatus] = useState("");
  const [apiLoading, setApiLoading] = useState(false);
  const [filterShow, setFilterShow] = useState(false);
  const [filter, setFilter] = useState<string[]>([]); 
  const [spinner, setSpinner] = useState(false);  
  const [refreshLoading, setRefreshLoading] = useState(false);  
  const [tableData, setTableData] = useState<Campaign[]>(campaigns);
  const [sortConfig, setSortConfig] = useState<{ key: keyof Campaign; direction: "asc" | "desc" }>({
  key: "name", 
  direction: "asc",
});
const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);




    // const previousProfileIdRef = useRef(localStorage.getItem("BudgetProfileId"));
    let Condition: any = [];
    let rows: any = [];
    let columns: GridColDef[] = [];

    
    const handleSort = (key: keyof Campaign) => {
      let direction: 'asc' | 'desc' = 'asc';
    
      if (sortConfig.key === key && sortConfig.direction === 'asc') {
        direction = 'desc';
      }
    
      const sortedData = [...campaigns].sort((a, b) => {
        const aValue = a[key];
        const bValue = b[key];
    
        if (typeof aValue === 'string' && typeof bValue === 'string') {
          return direction === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        }
    
        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return direction === 'asc' ? aValue - bValue : bValue - aValue;
        }
    
        if (aValue && bValue && typeof aValue === 'string' && typeof bValue === 'string') {
          const aDate = new Date(aValue);
          const bDate = new Date(bValue);
          return direction === 'asc' ? aDate.getTime() - bDate.getTime() : bDate.getTime() - aDate.getTime();
        }
    
        if (key === 'acos' || key === 'roas') {
          const aNumeric = aValue && typeof aValue === 'string' ? parseFloat(aValue.replace('%', '').trim()) : 0;
          const bNumeric = bValue && typeof bValue === 'string' ? parseFloat(bValue.replace('%', '').trim()) : 0;
          return direction === 'asc' ? aNumeric - bNumeric : bNumeric - aNumeric;
        }
    
        return 0; 
      });
    
      
      setSortConfig({ key, direction });
      setCampaigns(sortedData);
    };
    
    
  
    
    const fetchCampaigns = async (searchKeyFilter: string, selectedProfile: string, selectedstatus: string, activePage: number, perPage: number, condition: string) => {

      let userToken = localStorage.getItem("budgetOptimizer");
      let AuthToken = "Bearer " + userToken;
      let profileId = localStorage.getItem("BudgetProfileId")
      console.log(profileId,"BudgetProfileId")
      setSpinner(true);
      // if (previousProfileIdRef.current !== profileId) {
        try {
            const response = await fetch(
                `https://budget-api.getgrowth.agency/api/amazon/ads/${profileId}/listCampaigns`,
                {
                    method: 'POST', 
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: AuthToken,
                    },
                    body: JSON.stringify({
                        pageNo: activePage,
                        perPage:perPage ,
                        type: selectedProfile,
                        status:selectedstatus,
                        currencyCode: 'USD',
                        search: searchKeyFilter,
                        timezone: 'America/Los_Angeles',
                    }),
                }
            );

            if (!response.ok) {
                throw new Error('Failed to fetch campaigns data.');
            }

            const data = await response.json();
            if (data?.data) {
                setCampaigns(data.data);
                setTotalRow(data.totalRecords)
                setActivePage(data.currentPageNo)
                // setPerPage(data.totalPages)
                setLastPage(data.totalPages)
                
            }
            setSpinner(false);
            console.log(data.data, "Fetched Campaigns Data");
            // previousProfileIdRef.current = profileId;
        } catch (err) {
          setSpinner(false);
            console.error(err);
         } finally {
          setApiLoading(false); // Hide loading state
        }
      // }
    };
const refreshCampaigns=async()=>{
  let userToken = localStorage.getItem("budgetOptimizer");
  let AuthToken = "Bearer " + userToken;
  let profileId = localStorage.getItem("BudgetProfileId") 
  setRefreshLoading(true);

  try {
    const response = await fetch(
        `https://budget-api.getgrowth.agency/api/amazon/ads/${profileId}/refreshCampaigns`,
        {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
                Authorization: AuthToken,
            },
            body: JSON.stringify({
                pageNo: activePage,
                perPage:perPage ,
                type: selectedProfile,
                status:selectedstatus,
                currencyCode: 'USD',
                search: searchKeyFilter,
                timezone: 'America/Los_Angeles',
            }),
        }
        
    );

    if (!response.ok) {
        throw new Error('Failed to fetch campaigns data.');
    }

    const data = await response.json();
    toast.success(data?.message)
  } catch (err) {
    setRefreshLoading(false);
      console.error(err);
   } finally {
    setRefreshLoading(false); // Hide loading state
  }
}
    useEffect(() => {
        fetchCampaigns(searchKeyFilter,selectedProfile,selectedstatus,activePage,perPage,props.condition);
    }, [searchKeyFilter,selectedProfile,selectedstatus,activePage,perPage,props.condition]); 

    const applyDataLength = (e) => {
        console.log("dataSize: ", e.target.value);
        setActivePage(1)
        setPerPage(Number(e.target.value)) 
      };

      const handleChange = (event, value: number) => {
        setActivePage(Number(value))
      };

      const handleKeyDown = (event: any) => {
      if (event.key === "Enter") {
        setActivePage(1)
        setSearchKeyFilter(event.target.value);
        event.preventDefault();
      }
    };

    const handlestatus = (event: React.ChangeEvent<HTMLSelectElement>) => {
      setselectedstatus(event.target.value); 
    };

    const handleProfileChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setSelectedProfile(e.target.value);
    };

    const handleRefresh = () => {
      localStorage.removeItem("Sort");
      localStorage.removeItem("SortData");
      // window.location.reload();
      refreshCampaigns()
    };



const containerRef = useRef<HTMLDivElement | null>(null);
  const tableRef = useRef<HTMLTableElement | null>(null);
  const tableThRef = useRef<(HTMLTableCellElement | null)[]>([]);
  useEffect(() => {
    const table = tableRef.current;
    const headers = tableThRef.current;

    if (!table || headers.length === 0) return;

    headers.forEach((th, index) => {
      if (!th || index === headers.length - 1) return;

      const resizer = document.createElement('div');
      resizer.className = 'resizer';
      th.style.position = 'relative';
      resizer.style.cssText = `
      position: absolute;
      right: 0;
      top: 0;
      width: 5px;
      cursor: col-resize;
      user-select: none;
      height: 100%;
      z-index: 1;
    `;
      th.appendChild(resizer);

      let startX = 0;
      let startWidth = 0;

      const onMouseDown = (e: MouseEvent) => {
        startX = e.pageX;
        startWidth = th.offsetWidth;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      };

      const onMouseMove = (e: MouseEvent) => {
        const newWidth = startWidth + (e.pageX - startX);
        if (newWidth > 30) {
          th.style.width = `${newWidth}px`;
        }
      };

      const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };

      resizer.addEventListener('mousedown', onMouseDown);
    });
  }, []);

  
//  useEffect(() => {
//    const table = tableRef.current;
//    const headers = tableThRef.current;
 
//    if (!table || headers.length === 0) return;
 
//    headers.forEach((th, index) => {
//      if (!th || index === headers.length - 1) return;
 
//      const resizer = document.createElement('div');
//      resizer.className = 'resizer';
//      th.style.position = 'relative';
//      resizer.style.cssText = `
//        position: absolute;
//        right: 0;
//        top: 0;
//        width: 5px;
//        cursor: col-resize;
//        user-select: none;
//        height: 100%;
//        z-index: 1;
//      `;
//      th.appendChild(resizer);
 
//      let startX = 0;
//      let startWidth = 0;
//      let isResizing = false;
 
//      const onMouseDown = (e: MouseEvent) => {
//       e.preventDefault();
//       e.stopPropagation();
//        startX = e.pageX;
//        startWidth = th.offsetWidth;
//        isResizing = false;
//        document.addEventListener('mousemove', onMouseMove);
//        document.addEventListener('mouseup', onMouseUp);
//      };
 
//      const onMouseMove = (e: MouseEvent) => {
//       //  const newWidth = startWidth + (e.pageX - startX);
//       //  if (newWidth > 30) {
//       //    th.style.width = `${newWidth}px`;
//       //  }
//       // const deltaX = e.pageX - startX;
//       // if (Math.abs(deltaX) > 2) {
//       //   isResizing = true;
//       // const newWidth = startWidth + (e.pageX - startX);
//       // if (newWidth > 70) {
//       //   th.style.width = `${newWidth}px`;
//       //   th.style.minWidth = `70px`;
//       //   th.style.maxWidth = `${newWidth}px`;
//       //   // Force the table to grow
//       //   if (table) {
//       //     const totalWidth = Array.from(table.rows[0].cells).reduce((acc, cell) => {
//       //       return acc + cell.offsetWidth;
//       //     }, 0);
//       //     table.style.width = `${totalWidth}px`;
//       //   }
//       // }}
//       ////////////////////////////////////
//       const deltaX = e.pageX - startX;
//       const newWidth = startWidth + deltaX;
    
//       const minColWidth = 70;
//       const maxColWidth = 400;
//       if (Math.abs(deltaX) > 2) {
//         isResizing = true;
    
//         const clampedWidth = Math.max(minColWidth, Math.min(newWidth, maxColWidth));

//         // Set the resized column width
//         th.style.width = `${clampedWidth}px`;
//         th.style.minWidth = `${minColWidth}px`;
//         th.style.maxWidth = `${maxColWidth}px`;
    
        
//         headers.forEach((otherTh, i) => {
//           if (otherTh && otherTh !== th) {
//             otherTh.style.width = ''; // or set to default if you want
//             otherTh.style.minWidth = `${minColWidth}px`;
//             otherTh.style.maxWidth = `${maxColWidth}px`;
//           }
//         });
    
//         // ✅ Grow table so it doesn't compress
//         const totalWidth = Array.from(table.rows[0].cells).reduce(
//           (acc, cell) => acc + cell.offsetWidth,
//           0
//         );
//         table.style.width = `${totalWidth}px`;
//       }
    
//      };
 
//      const onMouseUp = (e: MouseEvent) => {
//        document.removeEventListener('mousemove', onMouseMove);
//        document.removeEventListener('mouseup', onMouseUp);

//        if (isResizing) {
//         e.stopPropagation();
//         const preventClick = (clickEvent: MouseEvent) => {
//           clickEvent.stopPropagation();
//           clickEvent.preventDefault();
//           th.removeEventListener('click', preventClick);
//         };
//         th.addEventListener('click', preventClick);
      
//        }
//      };
 
//      resizer.addEventListener('mousedown', onMouseDown);
//    });
//  }, []);


    return (
      <div style={{ height: 500, width: "100%" }}>  
          <Row className="mt-2 mb-2">
            <Col style={{justifyContent:"flex-end" ,display:"flex" }}>     
            <div className="campaigns" >
            <div
                className="d-flex align-items-center refresh-button me-2"
                onClick={handleRefresh}
              >
             {refreshLoading ? (
        <i className="fa-solid fa-arrows-rotate spin p-2 " style={{ animation: 'spin 1s infinite linear' }}></i> 
      ) : (
        <i className="fa-solid fa-arrows-rotate p-2"></i> 
      )} 
      {/* <i
              className="fa-solid fa-arrows-rotate p-2"
              style={{ color: "#9ca3af " }}
            ></i> */}
          </div>
          <div>
          </div>
      {/* <Row>
        <Col md={3} className="padding-lr-10"></Col>
        <Col md={9}> */}
          <div className="filters">
            {/* Uncomment and use the DateRangePicker if needed */}
            {/* 
            <DateRangePicker
              placeholder="Select Date Range"
              onChange={this.onChangeDateRangeSubmitGlobal}
              format="yyyy-MM-dd"
              disabledDate={(date) => isAfter(date, new Date())}
              defaultValue={[this.startDate, this.endDate]} 
            />
            */}
          </div>
          <div>
            <form>
              <div className="search-filter-container">
                <i className="fa fa-search"></i>
                <input
                  type="text"
                  placeholder="Search"
                  id="globalSearch"
                  name="globalSearch"
                  onChange={(e) => setSearchKeyFilter(e.target.value)} 
                  onKeyDown={handleKeyDown}
                />
              </div>
            </form>
          </div>
          <div className="accounts ms-2">
            <select
              className="form-select"
              name="accountSelect"
              id="accountSelect"
              style={{ height: "40px", paddingBottom: "10px" }}
              value={selectedProfile}
              onChange={handleProfileChange}
            >
              <option value="">All</option>
              <option value="Sponsored Products">Sponsored Products</option>
              <option value="Sponsored Brands">Sponsored Brands</option>
              <option value="Sponsored Display">Sponsored Display</option>
            </select>
          </div>
          <div className="accounts ms-2">
            <select
              className="form-select"
              name="accountStatus"
              id="accountStatus"
              style={{ height: "40px", paddingBottom: "10px" }}
              value={selectedstatus}
              onChange={handlestatus}
            >
              <option value="">All</option>
              <option value="ENABLED">Enabled</option>
              <option value="PAUSED">Paused</option>
              <option value="ARCHIVED">Archived</option>
              <option value="ENDED">Ended</option>
            </select>
          </div>
        {/* </Col>
      </Row> */}
    </div>

        </Col>
        </Row>
        <div>


                  {/* <table className="table table-bordered">
    <thead>
      <tr>
        <th>Firstname</th>
        <th>Lastname</th>
        <th>Email</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>John</td>
        <td>Doe</td>
        <td>john@example.com</td>
      </tr>
    
    </tbody>
  </table> */}




        <div className='Budget-table' ref={containerRef} >
             <table className="full-table table-bordered" ref={tableRef}   >
             
    
                <thead  className='table-heaads'>
                    <tr >
                        <th 
                          ref={el => tableThRef.current[0] = el}
                        
                        >Active</th>
                        <th 
                        ref={el => tableThRef.current[1] = el} 
                       
                        onMouseEnter={() => setHoveredColumn('campaignId')}
                        onMouseLeave={() => setHoveredColumn(null)}
                       
                       onClick={() => handleSort('campaignId')}>
                        Campaign ID 
                      <span className='sort-icon'>  {hoveredColumn === 'campaignId' || sortConfig.key === 'campaignId' ? (
                            sortConfig.key === 'campaignId' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th
                        ref={el => tableThRef.current[2] = el} 
                        onMouseEnter={() => setHoveredColumn('name')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('name')}>
                        Campaign Name
                       <span className='sort-icon'> {hoveredColumn === 'name' || sortConfig.key === 'name' ? (
                            sortConfig.key === 'name' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                       
                        <th 
                        ref={el => tableThRef.current[3] = el} 
                        onMouseEnter={() => setHoveredColumn('status')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('status')}>Status
                       <span className='sort-icon'> {hoveredColumn === 'status' || sortConfig.key === 'status' ? (
                            sortConfig.key === 'status' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[4] = el}  
                        onMouseEnter={() => setHoveredColumn('budget')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('budget')}>Budget
                        <span className='sort-icon'>{hoveredColumn === 'budget' || sortConfig.key === 'budget' ? (
                            sortConfig.key === 'budget' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[5] = el}  
                        onMouseEnter={() => setHoveredColumn('type')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('type')}>Campaign Type
                        <span className='sort-icon'> {hoveredColumn === 'type' || sortConfig.key === 'type' ? (
                            sortConfig.key === 'type' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[6] = el} 
                        onMouseEnter={() => setHoveredColumn('startDate')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('startDate')} >Start Date
                       <span className='sort-icon'> {hoveredColumn === 'startDate' || sortConfig.key === 'startDate' ? (
                            sortConfig.key === 'startDate' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[7] = el} 
                        onMouseEnter={() => setHoveredColumn('endDate')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('endDate')}>End Date
                         <span className='sort-icon'>{hoveredColumn === 'endDate' || sortConfig.key === 'endDate' ? (
                            sortConfig.key === 'endDate' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th  
                        ref={el => tableThRef.current[8] = el} 
                        onMouseEnter={() => setHoveredColumn('budgetType')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('budgetType')}>BudgetType
                        <span className='sort-icon'>{hoveredColumn === 'budgetType' || sortConfig.key === 'budgetType' ? (
                            sortConfig.key === 'budgetType' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[9] = el}
                        onMouseEnter={() => setHoveredColumn('spend')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('spend')}>Spend
                        <span className='sort-icon'>{hoveredColumn === 'spend' || sortConfig.key === 'spend' ? (
                            sortConfig.key === 'spend' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[10] = el}  
                        onMouseEnter={() => setHoveredColumn('sales')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('sales')}>Sales
                         <span className='sort-icon'>{hoveredColumn === 'sales' || sortConfig.key === 'sales' ? (
                            sortConfig.key === 'sales' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[11] = el} 
                         onMouseEnter={() => setHoveredColumn('acos')}
                         onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('acos')}>ACOS
                       <span className='sort-icon'>{hoveredColumn === 'acos' || sortConfig.key === 'acos' ? (
                            sortConfig.key === 'acos' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[12] = el}  
                        onMouseEnter={() => setHoveredColumn('roas')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('roas')}>ROAS
                       <span className='sort-icon'>{hoveredColumn === 'roas' || sortConfig.key === 'roas' ? (
                            sortConfig.key === 'roas' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[13] = el}  style={{ width: '150px', position: 'relative' }}
                        onMouseEnter={() => setHoveredColumn('impressions')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('impressions')} >Impressions
                        <span className='sort-icon'>{hoveredColumn === 'impressions' || sortConfig.key === 'impressions' ? (
                            sortConfig.key === 'impressions' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[14] = el}  style={{ width: '150px', position: 'relative' }}
                        onMouseEnter={() => setHoveredColumn('cpc')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('cpc')}>CPC
                       <span className='sort-icon'>{hoveredColumn === 'cpc' || sortConfig.key === 'cpc' ? (
                            sortConfig.key === 'cpc' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[15] = el}  style={{ width: '150px', position: 'relative' }}
                        onMouseEnter={() => setHoveredColumn('clicks')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('clicks')}>Clicks
                        <span className='sort-icon'>{hoveredColumn === 'clicks' || sortConfig.key === 'clicks' ? (
                            sortConfig.key === 'clicks' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                        <th 
                        ref={el => tableThRef.current[16] = el}  style={{ width: '150px', position: 'relative' }}
                        onMouseEnter={() => setHoveredColumn('orders')}
                        onMouseLeave={() => setHoveredColumn(null)}
                        onClick={() => handleSort('orders')}>Orders
                        <span className='sort-icon'>{hoveredColumn === 'orders' || sortConfig.key === 'orders' ? (
                            sortConfig.key === 'orders' ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : ' ↑'
                        ) : ''}</span>
                        </th>
                    </tr>
                </thead>
        <tbody className='tbody-td'>
  {spinner ? (
    <tr style={{ height: '450px' }}>
      <td colSpan={13} style={{ textAlign: 'center', verticalAlign: 'middle' }}>
        <div className="loading-container">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      </td>
    </tr>
  ) : Array.isArray(campaigns) && campaigns.length > 0 ? (
    campaigns.map((campaign) => (
      <tr key={campaign.campaignId}>
        <td>
          <label className="switch">
            <input type="checkbox" checked={campaign.status === "ENABLED"} disabled />
            <span className="slider"></span>
          </label>
        </td>
        <td>{campaign.campaignId}</td>
        <td>{campaign.name}</td>
        <td
          className={
            campaign.status === "DISABLED"
              ? "status-disabled"
              : campaign.status === "ENABLED"
              ? "status-enabled"
              : campaign.status === "PAUSED"
              ? "status-paused"
              : campaign.status === "ARCHIVED"
              ? "status-archived"
              : ""
          }
          style={{
            color:
              campaign.status === "DISABLED"
                ? "red"
                : campaign.status === "ENABLED"
                ? "green"
                : campaign.status === "PAUSED"
                ? "red"
                : campaign.status === "ARCHIVED"
                ? "blue"
                : "black",
          }}
        >
          {campaign.status}
        </td>
        <td>${campaign.budget.toFixed(2)}</td>
        <td>{campaign.type}</td>
        <td>{campaign.startDate}</td>
        <td>{campaign.endDate || '-'}</td>
        <td>{campaign.budgetType}</td>
        <td>${campaign.spend.toFixed(2)}</td>
        <td>${campaign.sales.toFixed(2)}</td>
        <td>{campaign.acos}%</td>
        <td>{campaign.roas}</td>
        <td>{campaign.impressions}</td>
        <td>${campaign.cpc}</td>
        <td>{campaign.clicks}</td>
        <td>{campaign.orders}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={17}>
        <div className="no-rows-container">
          No Rows
        </div>
      </td>
    </tr>
  )}
</tbody>





            </table> 
        </div>
        </div>
        
          <div className="custom-table-footer">
            <Row>
              <Col md={5}>
                <form className="table-footer-left">
                  <span>Show </span>
                  <label>
                    <select
                      className="form-select"
                      defaultValue={perPage}
                      onChange={(event) => applyDataLength(event)}
                    >
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="150">150</option>
                      <option value="200">200</option>
                    </select>
                  </label>
                  <span> of {totalRow} total entries</span>
                </form>
              </Col>
              <Col md={7}>
                <div className="table-footer-right">
                  <Stack spacing={2}>
                    <Pagination
                      count={lastPage}
                      page={activePage}
                      variant="outlined"
                      shape="rounded"
                      onChange={handleChange}
                    />
                  </Stack>
                </div>
              </Col>
            </Row>
          </div> 
          </div> 
    );

};

export default Campaigns;
